<template>
	<div class="container-sm mh-100 pt-10">
		<div class="pb-4 vstack gap-3">
			<div class="text-center">
				<router-link :to="{ name: 'home' }" class="d-inline-block">
					<img src="@/assets/img/logo/complete.png" class="h-rem-10" alt="logo">
				</router-link>
			</div>
			<div class="ls-tight lh-sm text-md text-center px-5 px-md-10">Seleccionar empresa</div>
			<div class="vstack gap-2 text-center">
				<template v-if="companies.length > 0">
					<CompanyCardSelect v-for="company in companies" v-bind:key="company.id" :company="company" />
				</template>
				<template v-else>
					<CommonMessageInfo info="No se encontraron empresas a las cuales tengas accceso." />
				</template>
			</div>
		</div>
		<div class="text-center fw-bold pb-10">
			¿Nada que hacer?
			<router-link :to="{ name: 'auth.logout' }" class="link-primary ps-2">Salir</router-link>
		</div>
	</div>
</template>

<script>
	import { computed } from 'vue';
	import store from '@/store';
	import _ from 'lodash';

	export default {
		setup() {
			const companies = computed(() => {
				return _.filter(store.getters['auth/user']?.companies, (company) => {
					return ['admin', 'leader'].some(valor => company.pivot.roles.includes(valor));
				});
			});

			return { companies };
		}
	}
</script>